<template>

    <div class="container">

        <app-head title="Contact" />

        <div class="my-4">
            <h1>{{ __('Individuelle Produktanfrage') }}</h1>
        </div>

        <p class="lead">
            Sie haben ein Produkt gesucht, in unserem Sortiment aber nicht gefunden? Sie wollen eine bestimmte Aufgabe lösen, aber kein konkretes Produkt dafür im Kopf?
        </p>
        <p>
            Mit diesem Formular können Sie uns Ihre Wünsche mitteilen, bspw. welches Gerät Sie konkret suchen oder welche Aufgabe damit gelöst werden soll.
        </p>
        <p>
            In unserem großen Netzwerk aus verschiedenen Zulieferern können wir dann für Sie recherchieren und melden uns dann umgehend bei Ihnen, wenn das Produkt verfügbar ist bzw. welches Produkt wir für diese Aufgabe empfehlen können.
        </p>

        <div class="row gx-5">

            <div class="col-md-6">
                <form @submit.prevent="submit">
                    <text-input :floating="true" label="Name" v-model="form.name" :error="form.errors.name" />
                    <div class="row row-cols-1 row-cols-md-2">
                        <div class="col">
                            <text-input :floating="true" label="email" v-model="form.email" type="email" :error="form.errors.email" />
                        </div>
                        <div class="col">
                            <text-input :floating="true" label="phone" v-model="form.phone" type="tel" :error="form.errors.phone" />
                        </div>
                    </div>
                    <textarea-input :floating="true" class-name="size-large" label="product_request" v-model="form.message" :error="form.errors.message" />
                    <submit-button :form="form" />
                </form>
            </div>

            <div class="col-md-6">

            </div>

        </div>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'productRequestData',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    email: null,
                    phone: null,
                    message: null,
                }),
            }
        },
        components: {
            TextInput,
            TextareaInput,
            SubmitButton,
        },
        methods: {
            submit() {
                this.form.post(route('product-request.submit'), {
                    onSuccess: () => this.form.reset(),
                })
            }
        },
    }
</script>